module.exports = __webpack_public_path__ + "static/media/alia.b9120665.svg";